import { IFormData } from '../../components/FormHelper/FormHelper.types';
import instance from './axios';

const ENDPOINTS = {
  DINING: '/dining',
  DINING_VENUE: '/dining/venues',
  PRIVATE_FUNCTION: '/private',
  VENUE: '/venues',
};

const getVenue = (type: 'private' | 'dining') => {
  switch (type) {
    case 'dining':
      return instance.get(ENDPOINTS.DINING + ENDPOINTS.VENUE);
    case 'private':
      return instance.get(ENDPOINTS.PRIVATE_FUNCTION + ENDPOINTS.VENUE);
  }

}

const postDiningRequest = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.DINING, data);
};

const postPrivateFunctionRequest = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.PRIVATE_FUNCTION, data);
}

const DiningApi = {
  postDiningRequest,
  getVenue,
  postPrivateFunctionRequest,
};

export default DiningApi;
